export const enterpriseColors = {
  blue: {
    50: "#DFE9F5",
    100: "#88AED5",
    200: "#0F5199",
    300: "#004A98",
    400: "#09315C",
    500: "#07203D",
    600: "#030c17",
  },
  blueGray: {
    50: "#F7FAFC",
    100: "#E7EAF4",
    500: "#2D3748",
  },
};
